// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { patchPreprocessedRecords } from 'services/MasspayoutService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useUpdatePreProcessedRecordMutation = () => {
  return useMutation({
    mutationFn: patchPreprocessedRecords,
    onError: (error: BaseErrorResponse, data) => {
      logSentryError('Error: useUpdateNetworkConnectionMutation', error, data)
    },
  })
}
